<span class="label" id="orgao">{{ label }}</span>
<p-select
	id="orgao_select"
	ariaLabelledBy="orgao"
	[formControl]="control"
	[options]="(options$ | async) || []"
	data-cy="orgao"
	[showClear]="true"
	[filter]="true"
	filterBy="codigo,sigla,nome"
	[placeholder]="placeholder"
	(onChange)="changed.emit($event.value)"
	emptyMessage="Nenhum órgão encontrado"
	emptyFilterMessage="Nenhum órgão encontrado"
>
	<ng-template #selectedItem>
		@if (control.value; as orgao) {
		<span>{{orgao.codigo}}</span>&nbsp;-&nbsp;<span>{{orgao.sigla}}</span>&nbsp;-&nbsp;
		<span>{{orgao.nome | titlecase}}</span>
		}
	</ng-template>
	<ng-template #item let-orgao>
		<div class="orgao-item">
			<span>{{orgao.codigo}}</span> - <span>{{orgao.sigla}}</span> -
			<span>{{orgao.nome | titlecase}}</span>
		</div>
	</ng-template>
</p-select>
<sgp-message-feedback mensagem="O campo é obrigatório" data-cy="erro-orgao-obrigatorio" [show]="showError" />
